import React from 'react';
import { OptimizedImage } from './optimized-image';

interface ResponsiveImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  webpSrc?: string;
  fallbackSrc?: string;
  sizes?: string;
  srcSet?: string;
  loading?: 'lazy' | 'eager';
  priority?: boolean;
}

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  src,
  webpSrc,
  fallbackSrc,
  sizes = '100vw',
  loading = 'lazy',
  priority = false,
  className,
  alt,
  ...props
}) => {
  // Use eager loading for priority images
  const loadingStrategy = priority ? 'eager' : loading;

  return (
    <OptimizedImage
      src={src}
      webpSrc={webpSrc}
      fallbackSrc={fallbackSrc}
      loading={loadingStrategy}
      sizes={sizes}
      className={className}
      alt={alt}
      {...props}
    />
  );
};